export default __webpack_public_path__ + "static/media/wait-members.9e209ba9.png";